import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestJob } from 'lib/selectors/getLatestJob';

const getLatestJobQuantity = createSelector([getLatestJob], (latestJob) => {
  return _get(latestJob, 'quantity', null);
});

export { getLatestJobQuantity };
